import { render, staticRenderFns } from "./purchaseInfo.vue?vue&type=template&id=3b7f15f2&scoped=true"
import script from "./purchaseInfo.vue?vue&type=script&lang=js"
export * from "./purchaseInfo.vue?vue&type=script&lang=js"
import style0 from "./purchaseInfo.vue?vue&type=style&index=0&id=3b7f15f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f15f2",
  null
  
)

export default component.exports